__turbopack_context__.v({
  "Content": "footer-module-scss-module__Bzwmpa__Content",
  "mailLink": "footer-module-scss-module__Bzwmpa__mailLink",
});
